import React from "react"
import { DeepReadonly } from "ts-essentials"
import AnalyticsContext from "connected-components/analytics/context"
import { useDashboardAnalytics } from "./use-dashboard-analytics"

interface DashboardAnalyticsProviderProps {
  children: React.ReactNode
}

/**
 * Provides dashboard analytics context with automatic property extraction
 * and "Dashboard" prefix for all events.
 *
 * This provider wraps children with analytics context that includes:
 * - Dashboard-specific context properties (modelId, instrumentId, etc.)
 * - "Dashboard" prefix for all tracked events
 * - Inheritance from parent analytics contexts if nested
 *
 */
export function DashboardAnalyticsProvider({
  children,
}: DeepReadonly<DashboardAnalyticsProviderProps>) {
  const analyticsContextValue = useDashboardAnalytics()

  return (
    <AnalyticsContext.Provider value={analyticsContextValue}>
      {children}
    </AnalyticsContext.Provider>
  )
}

export default DashboardAnalyticsProvider
